import React, { useState } from 'react'
import { Button, TextArea } from '../ui'

export function CommentsSection({ comments = [], currentUserId, onAdd, onDelete }) {
  const [draft, setDraft] = useState('')
  const [sending, setSending] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    const text = draft.trim()
    if (!text) return
    setSending(true)
    try {
      await onAdd?.(text)
      setDraft('')
    } finally {
      setSending(false)
    }
  }

  return (
    <div style={styles.wrapper}>
      <span style={styles.heading}>Comments{comments.length > 0 ? ` (${comments.length})` : ''}</span>
      {comments.map((c) => (
        <div key={c.entryId} style={styles.comment}>
          <div style={styles.commentHeader}>
            <span style={styles.author}>{c.createdByName || c.createdBy}</span>
            <span style={styles.ts}>
              {new Date(c.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
            </span>
            {c.createdBy === currentUserId && (
              <button
                type="button"
                style={styles.deleteBtn}
                onClick={() => onDelete?.(c.entryId)}
                aria-label="Delete comment"
              >×</button>
            )}
          </div>
          <p style={styles.body}>{c.text}</p>
        </div>
      ))}
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={{ flex: 1 }}>
          <TextArea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Add a comment..."
            maxLength={500}
            disabled={sending}
            rows={2}
            aria-label="Add a comment"
          />
        </div>
        <Button
          type="submit"
          size="sm"
          disabled={!draft.trim()}
          loading={sending}
          loadingLabel="…"
        >
          Send
        </Button>
      </form>
    </div>
  )
}

const styles = {
  wrapper: { display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' },
  heading: {
    fontSize: 10,
    fontWeight: 600,
    color: 'var(--text-secondary)',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
  },
  comment: { display: 'flex', flexDirection: 'column', gap: 2 },
  commentHeader: { display: 'flex', alignItems: 'center', gap: 'var(--space-1)' },
  author: { fontSize: 11, fontWeight: 500, color: 'var(--text-primary)' },
  ts: { fontSize: 10, color: 'var(--text-secondary)' },
  // Icon-only delete affordance — Phase 6 will replace with IconButton.
  deleteBtn: {
    marginLeft: 'auto',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    color: 'var(--text-secondary)',
    padding: '0 2px',
    opacity: 0.6,
    lineHeight: 1,
  },
  body: { fontSize: 12, color: 'var(--text-primary)', margin: 0, lineHeight: 1.5 },
  form: { display: 'flex', gap: 'var(--space-1)', marginTop: 'var(--space-1)', alignItems: 'flex-end' },
}
